import { apiClient } from '@/shared/api';
import type { Rule, CreateRuleInput, UpdateRuleInput, PaginatedRules } from './types';

interface ListRulesParams {
  page?: number;
  limit?: number;
}

interface BackendRulesResponse {
  data: Rule[];
  total: number;
  page: number;
  limit: number;
}

export const rulesApi = {
  list: async ({ page = 1, limit = 5 }: ListRulesParams = {}): Promise<PaginatedRules> => {
    const params = new URLSearchParams();
    params.set('page', page.toString());
    params.set('limit', limit.toString());
    const response = await apiClient.get<BackendRulesResponse>(`/rules?${params}`);
    return {
      data: response.data || [],
      pagination: {
        page: response.page || 1,
        limit: response.limit || limit,
        total: response.total || 0,
        totalPages: Math.ceil((response.total || 0) / (response.limit || limit)),
      },
    };
  },

  get: (id: string) =>
    apiClient.get<Rule>(`/rules/${id}`),

  create: (data: CreateRuleInput) =>
    apiClient.post<Rule>('/rules', data),

  update: (id: string, data: UpdateRuleInput) =>
    apiClient.patch<Rule>(`/rules/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/rules/${id}`),

  reorder: (ruleIds: string[]) =>
    apiClient.put('/rules/reorder', { ruleIds }),

  toggle: (id: string, enabled: boolean) =>
    apiClient.patch<Rule>(`/rules/${id}`, { enabled }),
};
